// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"32cf3315","775":"faca1d51","863":"f7d964f5"}[chunkId] + ".chunk.css";
};